<template>
  <div class="flex items-center gap-2">
    <SNumberField
      :model-value="modelValue"
      :min="1"
      :max="max"
      :disabled="disabled"
      class="w-28"
      data-cy="check-in-stepper"
      @update:model-value="onChange"
    >
      <SNumberFieldContent>
        <SNumberFieldDecrement />
        <SNumberFieldInput />
        <SNumberFieldIncrement />
      </SNumberFieldContent>
    </SNumberField>

    <span class="text-xs whitespace-nowrap text-gray-500">
      {{ $t("check-in.of-n-left", { count: max }) }}
    </span>
  </div>
</template>

<script lang="ts">
/**
 * Quantity to check in on one line, capped at what is still open.
 *
 * @component
 * @prop {number} modelValue - Visitors to check in on this line.
 * @prop {number} max - Tickets still open on this line.
 * @prop {boolean} disabled - Turns the stepper off.
 * @fires change - The operator picked another quantity.
 * @example
 * <CheckInQuantityCell :model-value="3" :max="5" @change="onChange" />
 */
export default { name: "CheckInQuantityCell" };
</script>

<script lang="ts" setup>
import {
  SNumberField,
  SNumberFieldContent,
  SNumberFieldDecrement,
  SNumberFieldIncrement,
  SNumberFieldInput,
} from "@smeetz/ui-core";

defineProps<{
  modelValue: number;
  max: number;
  disabled: boolean;
}>();

const emit = defineEmits<{ (event: "change", value: number): void }>();

/**
 * Send the new quantity to the page.
 *
 * @param {number} value - The quantity the operator picked.
 * @returns {void}
 */
function onChange(value: number): void {
  emit("change", Number(value) || 0);
}
</script>
